import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { CalculatorTextProps } from './types';

export const CalculatorText: FC<CalculatorTextProps> = ({ labelKey, href }) => (
  <p className={'font-satoshiMedium text-ash text-ms m-0 font-medium'}>
    <FormattedMessage
      id={labelKey}
      values={{
        a: text => (
          <a target={'_blank'} rel={'noreferrer'} href={href}>
            {text}
          </a>
        ),
      }}
    />
  </p>
);
